import { 
    faAngleRight, faDotCircle
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

export const TransactionsList = ({status, name, category, rise, date, desc}) => {
    return (
        <table className="w-100 border-bottom my-2">
            <tr>
                <td rowSpan="2">{status === 'Completed' ? <FontAwesomeIcon icon={faDotCircle} className="text-success" /> 
                : status === 'Pending'? <FontAwesomeIcon icon={faDotCircle} className="text-warning" /> 
                : <FontAwesomeIcon icon={faDotCircle} className="text-danger" />} </td>
                <td className>{name}</td>
                <td className rowSpan="2">{category}</td>
                <td className="text-right"><span className="text-danger rounded p-1">{rise}</span></td>
            </tr>
            <tr className="text-muted small">
                <td>{desc}</td>
                <td className="text-right">{date}</td>
            </tr>
        </table>
    )
}


export const Display = ({title, amount}) => {
    return (
        <div className="float-md-left mx-2">
            <h5 className="text-light border-bottom">{title}</h5>
            <h2><span style={{textDecoration: 'double line-through'}}>N</span>{amount}</h2>
            <h6 className="text-light">${amount/500}</h6>
            {title === 'Total Balance' ?
                <Link to="#" className="small badge badge-light text-purple" type="button" data-toggle="modal" data-target="#modalBalanceStatement">View Statement <FontAwesomeIcon icon={faAngleRight} className="ml-2" /></Link>
                : title === 'Total Income' ?
                    <Link to="#" className="small badge badge-light text-purple" type="button" data-toggle="modal" data-target="#modalIncomeStatement">View Statement <FontAwesomeIcon icon={faAngleRight} className="ml-2" /></Link>
                    : title === 'Total Remittance'?
                        <Link to='#' className="small badge badge-light text-purple" type="button" data-toggle="modal" data-target="#modalRemittanceStatement">View Statement <FontAwesomeIcon icon={faAngleRight} className="ml-2" /></Link>
                        : ''
            }
        </div>
    )
}

export const DepositOrWithdraw = ({title, icon}) => {
    return <Link to="#" className="btn btn-primary my-1 mx-2"><FontAwesomeIcon icon={icon} /> {title}</Link>
}

export const Transactions = ({name, rise, date, desc}) => {
    return (
        <table className="w-100 border-bottom my-2">
            <tr>
                <td>{name}</td>
                <td className="text-right"><span className="text-danger rounded p-1">{rise}</span></td>
            </tr>
            <tr className="text-muted small">
                <td>{desc}</td>
                <td className="text-right">{date}</td>
            </tr>
        </table>
    )
}